import script from "./ReviewSubmission.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewSubmission.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewSubmission.vue?vue&type=style&index=0&id=50c6d1b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50c6d1b7"]])

export default __exports__